<template>
  <div class="middleSection">
    <div class="wellnessEvents">
      <!-- // foreach -->
      <div v-for="event in computedEvents" :key="event.event_id">
        <article
          class="
            singleEvent
            dark:bg-hero-purple dark:border-hero-purple dark:text-white
          "
        >
          <div class="singleEventSplit">
            <div class="singleEventSplitLeft">
              <div class="singleEventSplitLeftText font-bold">
                {{ event.event_start.month }}
              </div>
              <div class="singleEventSplitLeftTextNumber">
                {{ event.event_start.day }}
              </div>
            </div>
            <div class="singleEventSplitRight">
              <h3 class="singleEventSplitRightText">
                {{ event.event_title }}
              </h3>
              <span class="text-xs">
                <svg
                  width="14"
                  class="float-left mt-2"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.185 0C10.6045 0 13.375 2.77052 13.375 6.19C13.375 9.60948 10.6045 12.38 7.185 12.38C3.76552 12.38 0.995 9.60948 0.995 6.19C0.995 2.77052 3.76552 0 7.185 0ZM7.185 11.1819C9.94304 11.1819 12.1769 8.94804 12.1769 6.19C12.1769 3.43196 9.94304 1.19806 7.185 1.19806C4.42696 1.19806 2.19306 3.43196 2.19306 6.19C2.19306 8.94804 4.42696 11.1819 7.185 11.1819ZM5.64249 8.57615L7.76157 7.03613C7.83894 6.97873 7.88387 6.88887 7.88387 6.79402V2.69565C7.88387 2.53091 7.74909 2.39613 7.58435 2.39613H6.78565C6.62091 2.39613 6.48613 2.53091 6.48613 2.69565V6.23243L4.81882 7.44547C4.68404 7.54281 4.65658 7.73001 4.75393 7.86479L5.22317 8.51125C5.32051 8.64354 5.50771 8.67349 5.64249 8.57615Z"
                    fill="#979797"
                  />
                </svg>

                <span class="ml-2">{{
                  moment(event.event_start.time, "HH:mm a").format("h:mm a")
                }}</span>
              </span>
            </div>
          </div>
        </article>
      </div>
      <a
        href="https://students.carleton.ca/events"
        target="_blank"
        tabindex="0"
        class="wellnessEventsCalendarLink dark:text-link-light-blue pb-0.5"
        >View the complete student events calendar</a
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import store from "../store";
export default {
  name: "EventsListing",

  data() {
    return {
      events: [],
      someVal: false,
      limit: 5
    };
  },
  mounted() {
    axios
      .get("https://students.carleton.ca/wp-json/stu-api/v2/events/pillar/wellness")
      .then((response) => (this.events = response.data))
      .finally(this.commitToStore());
    // this.commitToStore();
  },
  methods: {
    commitToStore() {
      this.someVal = true;
      /*store.commit("set_store_method");*/
    },
  },
  computed:{
    computedEvents(){
      return this.events.slice(0,5);
    }
  }
};
</script>

<style lang="css" scoped></style>
